import { BookingStatusMap } from "utils/interfaces"

export const StatusText = {
    [BookingStatusMap.NOT_PAID]: "Не подтверждено",
    [BookingStatusMap.PAY_STARTED]: "Ожидаем подтверждение",
    [BookingStatusMap.PAY_ERROR]: "Ошибка оплаты",
    [BookingStatusMap.PAID]: "Подтверждено",
    [BookingStatusMap.CANCELLED]: "Отменено",
    [BookingStatusMap.CANCELLED_AFTER_PAYMENT]: "Отменено",
    [BookingStatusMap.CANCELLED_WITHOUT_REFUND]: "Отменено",
    [BookingStatusMap.PAID_AFTER_CANCELLATION]: "Подтверждено",
} as const
